import {Component, OnInit} from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {Event} from '../models/event';
import {EventService} from '../services/event.service';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {EventPreviewService} from '../services/event-preview.service';
import {AuthService} from '../services/auth.service';
import {Router} from "@angular/router";
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {KnowledgeService} from '../services/knowledge.service';
import {EventDialogComponent} from '../event/dialogs/event-dialog/event-dialog.component';

@Component({
  selector: 'app-congress-historic',
  templateUrl: './congress-historic.component.html',
  styleUrls: [ './congress-historic.component.scss' ],
  entryComponents: [
    EventDialogComponent,
    ConfirmComponent
  ]
})

export class CongressHistoricComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'date', 'name', 'edit', 'undo' ];

  constructor (
    private db: AngularFirestore,
    public _authService: AuthService,
    public _eventService: EventService,
    public _knowledgeService: KnowledgeService,
    public _eventPreviewService: EventPreviewService,
    public dialog: MatDialog,
    public router: Router) {

    if (!this._authService.isAdmin) {
      this.router.navigate([ 'home' ]);
    }

  }

  ngOnInit () {
    this._eventService.isCongress = true;
    this._eventService.isDeleted = true;
    this.sub = this._eventService.select(null, this._eventService.isCongress, this._eventService.isDeleted)
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog (event) {

    let eventData: any = {};

    if (event) {
      eventData = event;
    } else {
      eventData = new Event();
    }

    eventData.isHistoric = true;

    this.dialog.open(EventDialogComponent, {
      panelClass: 'custom-dialog-container',

      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      
      hasBackdrop: true,
      disableClose: true,
      data: eventData
    });

  }


  undo (element) {

    let event_id = element.id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Restaurar este Evento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._eventService.undo(event_id)
          .then(() => {
            console.log("undo delete event success")
          })
          .catch(() => {
            console.log("undo delete error event")
          })


      }
    })
  }

}
